import React from 'react';
import AccordionChecklistItemData from '../../components/AccordionItemChecklist';
import HeroBanner from '../../components/HeroBanner';
import Breadcrumbs from '../../components/Breadcrumb';
import { useChecklist } from '../../context/ChecklistContext';
import { getChecklistStatus } from '../../utils/checklistUtils';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import consentFormImg from '../../assets/images/siteImg/checklistImg/Image_ConsentForms.png';
import schoolDocImg from '../../assets/images/siteImg/checklistImg/Image_SchoolDocuments.png';
import config from '../../config';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useOverviewContext } from '../../context/OverviewContext';
import bannerImage from '../../assets/images/banners/bannerImage_FormsDocs.png';

const MainChecklistFormsDocs = () => {
type ChecklistItem ={
    title: string;
    description: string;
    imageUrl: string;
    linkUrl: string;
    status: string;
}
const { HOME, SCHOOL_PREP_CHECKLIST, MAIN_CHECKLIST_DOMAIN } = config.app.routes;
// Check if any student is in Elementary or Middle School in LC login 
const { hasNonHighSchoolStudents } = useOverviewContext(); 
const { checklistData, checklistTopicStatus } = useChecklist();
// Filter checklist items for the "FORMS_AND_DOCUMENTS" category & highSchool Logic
const formsAndDocsChecklists = checklistData.filter(item => 
    item.checklistCategoryName === "FORMS_AND_DOCUMENTS" &&
    (hasNonHighSchoolStudents || item.checklistName !== "CONSENT_PROCESS")
);
// get unique category name capitalization format
const categoryName = formsAndDocsChecklists.length > 0
  ? formsAndDocsChecklists[0].checklistCategoryName
      .toLowerCase()
      .replace(/_/g, " ")
      .split(" ")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  : "Forms And Documents";
// const categoryName = "Forms and Documents";

// Prepare data from both frontend & API to each checklist item
const checklistItems_arr = [
    {
        description: 'Consent Process Easily indicate which activities your student may participate in.',
        imageUrl: consentFormImg,
    },
    {
        description: 'Easily access your enrollment portal here to complete any outstanding tasks and view your acknowledgment of school policies.',
        imageUrl: schoolDocImg
    }
];
const checklistWithStatus = formsAndDocsChecklists.map((item, index) => ({
    ...checklistItems_arr[index],
    title: item.description,
    checklistId: item.checklistId,
    status: getChecklistStatus(item.checklistId, checklistTopicStatus),
    linkUrl: `${MAIN_CHECKLIST_DOMAIN}/${item.checklistName.toLowerCase().replace(/_/g, '-')}`,
}));
const breadcrumbItems = [
    { label: "Home", path: HOME },
    { label: "School Prep Checklist", path: SCHOOL_PREP_CHECKLIST },
    { label: categoryName }, 
];
console.log(hasNonHighSchoolStudents, checklistWithStatus);
return (
    <div className="home-layout">
    <div className="sidebar-wrapper">
    <Sidebar />
    </div>
    <div className="body-wrapper-content">
    <div className="row">
        <div className="col-12">
        <Header />
        <main id="main" role="main">
            <div className="main-content" id="form-doc-category">
                <div className="row">
                    <div className="col-12">
                        <Breadcrumbs items={breadcrumbItems} />
                    </div>
                </div>

                <HeroBanner
                   title={categoryName}
                    subtitle="Get all the details in place!"
                    imageUrl={bannerImage}
                    altText={categoryName}
                    customClass="bg-color-blue-t1-checklist common-banner-bg-white"
                />

                <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                    <div className="wp-block-k12-section container-fluid bg-transparent">
                        <div className="row">
                            <div className="col-12 g-0">
                                <div className="wp-block-k12-checklist-grid container-fluid">
                                    <div className="row">
                                        <div className="col-12">
                                        <ul id="ChecklistItemSection">
                                            {checklistWithStatus.map((item: ChecklistItem, index: number) => (
                                                <AccordionChecklistItemData
                                                key={index}
                                                title={item.title}
                                                description={item.description}
                                                imageUrl={item.imageUrl}
                                                linkUrl={item.linkUrl}
                                                status={item.status}
                                                />
                                            ))}
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                </div>
                </div>
            </div>
        </main>
        </div>
    </div>

    </div>
    <FooterMobile />
</div>

    
);
};

export default MainChecklistFormsDocs;
